export const ingresoFirma = {
    "token": "",
    "origen": "",
}
